import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Container } from "./index.style";

const Navigation = ({ data, onNavigate }) => {
  const location = useLocation();

  return (
    <Container>
      {data.map((item, i) => (
        <Link
          className={location?.pathname === item.link ? "active" : ""}
          key={i}
          to={item.link}
          onClick={onNavigate}
        >
          <span>{item.title}</span>
        </Link>
      ))}
    </Container>
  );
};

export default Navigation;
